import { render, staticRenderFns } from "./ColorPick.vue?vue&type=template&id=64c9f228"
import script from "./ColorPick.vue?vue&type=script&lang=js"
export * from "./ColorPick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports